export const SwimmingPool = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0012 10.9996V3.34641C15.0018 2.60075 15.6061 1.9964 16.3518 1.99585H16.7519"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99872 10.9996V3.34641C8.99927 2.60075 9.60361 1.9964 10.3493 1.99585H10.7494"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99872 9.49899H15.0012"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99872 5.99752H15.0012"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99747 5.99744C4.33992 5.99744 2.99622 7.34114 2.99622 8.99869V18.0024C2.99622 19.66 4.33992 21.0037 5.99747 21.0037H18.0025C19.66 21.0037 21.0037 19.66 21.0037 18.0024V8.99869C21.0037 7.34114 19.66 5.99744 18.0025 5.99744"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.59778 13.8688C7.74427 14.378 9.05279 14.378 10.1993 13.8688C11.3458 13.3595 12.6543 13.3595 13.8008 13.8688C14.9473 14.378 16.2558 14.378 17.4023 13.8688"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.59778 17.3843C7.74427 17.8935 9.05279 17.8935 10.1993 17.3843C11.3458 16.875 12.6543 16.875 13.8008 17.3843C14.9473 17.8935 16.2558 17.8935 17.4023 17.3843"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Swimming Pool</div>
    </div>
  );
};

export const ValleyView = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="18.0075"
          height="18.0075"
          rx="5"
          transform="matrix(1 0 0 -1 2.99622 21.0038)"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.3244 15.6781L15.3248 15.6786C15.4226 15.7761 15.5808 15.7759 15.6784 15.6782C15.776 15.5805 15.7759 15.4223 15.6783 15.3247C15.5807 15.227 15.4224 15.227 15.3247 15.3245C15.227 15.4221 15.2269 15.5804 15.3244 15.6781"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0037 13.834V12.795C21.0037 11.5229 20.4984 10.3028 19.5988 9.40322C18.6992 8.50366 17.4791 7.9983 16.207 7.9983V7.9983C14.8067 7.9983 13.4763 8.61018 12.565 9.67335L9.02385 13.8047C8.37292 14.5641 7.42265 15.0012 6.42244 15.0012V15.0012C4.5302 15.0012 2.99622 13.4672 2.99622 11.575V9.16543"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Valley View</div>
    </div>
  );
};

export const Park = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.29254 8.29214L5.29454 11.2932C5.00873 11.5793 4.92335 12.0094 5.0782 12.3829C5.23305 12.7565 5.59764 13 6.00202 13H11.998C12.4024 13 12.767 12.7565 12.9218 12.3829C13.0767 12.0093 12.9913 11.5793 12.7055 11.2932L9.7075 8.29213C9.31626 7.90262 8.68377 7.90262 8.29254 8.29214V8.29214Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9501 13L13.7644 16.3576C14.014 16.6554 14.0686 17.0708 13.9043 17.4229C13.74 17.7749 13.3866 18 12.9981 18H5.00191C4.61337 18 4.26 17.7749 4.09571 17.4229C3.93141 17.0708 3.98593 16.6554 4.23553 16.3576L7.04992 13"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 21H21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 17V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.0994 10.5C21.0762 11.6927 21.2761 13.3422 20.6126 14.7336C19.9491 16.1251 18.5415 17.0081 17 17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="4.5"
          cy="4.5"
          r="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.0994 10.4999C21.202 9.13385 21.2828 7.20786 20.2986 5.75418C19.3145 4.3005 17.4962 3.66022 15.8184 4.1765C14.1405 4.69277 12.9967 6.24445 13 7.99994"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Park</div>
    </div>
  );
};

export const Balcony = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3"
          y="18"
          width="18"
          height="3"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 17.9834V10C19 6.13401 15.866 3 12 3V3C8.13401 3 5 6.13401 5 10V17.9834"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 18V4"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 11H5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Balcony</div>
    </div>
  );
};
